import {latestVersion} from 'powtoon-versioning'
import {EMPTY_MANIFEST, DEFAULT_METADATA} from './index'
import {createNewSlide} from '../utils'

const allowedAspectRatio = ['none', 'square', 'vertical']

export function createEmptyDocument(ratioMethod, created = null) {
  ratioMethod = allowedAspectRatio.indexOf(ratioMethod) !== -1 ? ratioMethod : 'none'

  return {
    permissions: {
      duration: 300
    },
    name: 'untitled-1',
    enableRichText: true,
    content: {
      powtoon: {
        manifest: EMPTY_MANIFEST,
        slides: [createNewSlide()],
        audioTracks: [null, null],
        transitions: {},
        styleDefs: {},
        baseResolution: {
          width: 1024,
          height: 576
        },
        exportAspectRatio: {
          method: ratioMethod
        },
        masters: {
          tracks: {
            back: [],
            front: []
          }
        }
      },
      metadata: {
        ...created,
        ...DEFAULT_METADATA
      },
      version: latestVersion
    }
  }
}
